module.exports = __webpack_public_path__ + "static/img/wanglaoshi.ace44f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/wanglaoshi.png
// module id = gtXe
// module chunks = 1